import LoggedInRoute from "@ch/components/PrivateRoute/LoggedInRoute";
import type { TRouteObject } from "@ch/helpers/utils/types";
import AuthenticationPageLazy from "@ch/pages/AuthenticationPage";
import ErrorPage from "@ch/pages/ErrorPage";
import ForgotPasswordPageLazy from "@ch/pages/ForgotPasswordPage";
import LoginPageLazy from "@ch/pages/LoginPage";
import NotFoundPage from "@ch/pages/NotFoundPage";
import PersonalInformationPageLazy from "@ch/pages/PersonalInformationPage";
import RegisterPageLazy from "@ch/pages/RegisterPage";
import ResetPasswordPageLazy from "@ch/pages/ResetPasswordPage";
import VerifyAccountPageLazy from "@ch/pages/VerifyAccountPage";
import { AuthPathsEnum } from "./enums";

const AuthRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <AuthenticationPageLazy />,
      },
      {
        path: AuthPathsEnum.LOGIN,
        element: <LoginPageLazy />,
      },
      {
        path: AuthPathsEnum.REGISTER,
        element: <RegisterPageLazy />,
      },
      {
        path: AuthPathsEnum.VERIFY_ACCOUNT,
        element: <VerifyAccountPageLazy />,
      },
      {
        path: AuthPathsEnum.PERSONAL_INFORMATION_DETAILS,
        element: (
          <LoggedInRoute>
            <PersonalInformationPageLazy />
          </LoggedInRoute>
        ),
      },
      {
        path: AuthPathsEnum.FORGOT_PASSWORD,
        element: <ForgotPasswordPageLazy />,
      },
      {
        path: AuthPathsEnum.RESET_PASSWORD,
        element: <ResetPasswordPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default AuthRoutes;
